export default __webpack_public_path__ + "src/assets/icn-buy.bbb50e92df5b429692a46490351786b1.svg";